import { useEffect, useSyncExternalStore } from 'react';
import { webSocketService } from '@/services/websocket';
import { useAuthUser } from '@/hooks/useAuthUser';

function subscribeToWebSocket(callback: () => void) {
    return webSocketService.onConnectionChange(() => callback());
}

function getSnapshot() {
    return webSocketService.isConnected();
}

function getServerSnapshot() {
    return false;
}

export function useWebSocketConnection() {
    const { user } = useAuthUser();

    const shouldConnect = !!user;

    useEffect(() => {
        if (shouldConnect) {
            webSocketService.connect();
        } else {
            webSocketService.disconnect();
        }

        return () => {
            webSocketService.disconnect();
        };
    }, [shouldConnect]);
}

export function useWebSocketStatus() {
    return useSyncExternalStore(
        subscribeToWebSocket,
        getSnapshot,
        getServerSnapshot,
    );
}
